import React from 'react';
import { Link } from 'react-router-dom';
import { PRODUCT_NAME_MARKETING } from '../../../constants';
import { T05_FOOTER_PRODUCTS, t05ProductIconSrc } from './t05FooterProducts';

export type T05SiteFooterVariant = 'landing' | 'product';

export interface T05SiteFooterProps {
  variant?: T05SiteFooterVariant;
}

export const T05SiteFooter: React.FC<T05SiteFooterProps> = ({ variant = 'landing' }) => {
  return (
    <footer
      className="t05-footer t05-container"
      {...(variant === 'landing' ? { 'data-section-motion': 'from-left' } : {})}
    >
      <div className="t05-footer__products">
        <p className="t05-footer__products-kicker">Orbis — alle Produkte</p>
        <nav className="t05-footer__products-grid" aria-label="Sub-Produkte">
          {T05_FOOTER_PRODUCTS.map((product) => (
            <Link
              key={product.id}
              to={product.route}
              className="t05-footer__product-card"
              data-product={product.id}
              aria-label={product.label}
            >
              <span className="t05-footer__product-visual">
                <img
                  src={t05ProductIconSrc(product.iconFile)}
                  alt=""
                  width={88}
                  height={88}
                  loading="lazy"
                  decoding="async"
                />
              </span>
            </Link>
          ))}
        </nav>
      </div>

      <div className="t05-footer__inner">
        {variant === 'landing' ? (
          <span>© {new Date().getFullYear()} ARKORBIT AI Austria</span>
        ) : (
          <span>
            {PRODUCT_NAME_MARKETING} · Self-Hosted · EU
          </span>
        )}

        <nav className="t05-footer__nav" aria-label={variant === 'landing' ? 'Rechtliches' : 'Fußnavigation'}>
          {variant === 'landing' ? (
            <>
              <Link to="/recht">Rechtliches</Link>
              <Link to="/recht#agb">AGB &amp; AVV</Link>
              <Link to="/recht#datenschutz">Datenschutz</Link>
            </>
          ) : (
            <>
              <Link to="/">Startseite</Link>
              <Link to="/recht">Rechtliches</Link>
            </>
          )}
        </nav>

        {variant === 'landing' && (
          <a href="mailto:office@arkorbit.at" className="t05-footer__nav">
            office@arkorbit.at
          </a>
        )}
      </div>
    </footer>
  );
};
